import React from 'react';
import ProjectCard from './projectCard';
import ProjectCardLoader from './projectCardLoader';

import { ReactComponent as NoProjectIlls } from 'assets/images/noProjectIlls.svg';

export default function DeactivatedProjects({ getAllProjects }) {
  return (
    <div>
      {getAllProjects?.isLoading ? (
        // loader
        <div className='flex flex-wrap'>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
          <div className='w-1/3 pr-8 pb-8'>
            <ProjectCardLoader />
          </div>
        </div>
      ) : (
        <>
          {getAllProjects?.data?.data?.length ? (
            <div className='flex flex-wrap'>
              {getAllProjects?.data?.data?.map((item) => (
                <div key={item?.id} className='w-1/3 pr-8 pb-8'>
                  <ProjectCard item={item} />
                </div>
              ))}
            </div>
          ) : (
            <div className='bg-white shadow-lg border border-gray border-opacity-10 min-h-[70vh] mt-2 rounded-lg'>
              <div className='flex flex-col justify-center items-center h-[70vh]'>
                <NoProjectIlls />
                <p className='text-gray3 text-xl pt-4'>
                  No inactive projects to show
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
